/* @flow */

import React, { createContext, useContext, useState } from "react";
import useCustomer from "helpers/use-customer";
import { StoreInfoContext } from "entrypoint/shared";

type Notifications = {
  showNotificationBar: boolean,
  setShowNotificationBar: (value: boolean) => void,
  showAddressNotificationBar: boolean,
  setShowAddressNotificationBar: (value: boolean) => void,
  activeNotification: boolean,
  multipleNotifications: boolean,
};

const NotificationContext = createContext<Notifications>({});

export const NotificationProvider = ({ children }: { children: React$Node }) => {
  const { info } = useContext(StoreInfoContext);
  const { missingAddress } = useCustomer();

  const [showNotificationBar, setShowNotificationBar] = useState(Boolean(info.popUp?.body));
  const [showAddressNotificationBar, setShowAddressNotificationBar] = useState(missingAddress);

  const activeNotification = showNotificationBar || showAddressNotificationBar;

  const multipleNotifications = showNotificationBar && showAddressNotificationBar;

  const value = {
    showNotificationBar,
    setShowNotificationBar,
    showAddressNotificationBar,
    setShowAddressNotificationBar,
    activeNotification,
    multipleNotifications,
  };

  return <NotificationContext.Provider value={value}>{children}</NotificationContext.Provider>;
};

export const useNotification = (): Notifications => {
  const context = useContext(NotificationContext);

  if (!context) {
    throw new Error("useNotification() must be used within NotificationProvider");
  }

  return context;
};
